import BaseStore from 'fluxible/addons/BaseStore';
import Actions from "../constants/Actions";

class UserfavouriteStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.userfavourite = [];
    this.inputs = [];
  }
  handleUserfavourite(data) {
    this.userfavourite = data.data;
    this.inputs = data.inputs;
    this.emitChange();
  }
  handleUpdateFeedbackUserfavourite(data) {
    // TODO:
    data.results = data.results.map(function(result) {
      result.index = result.index + data.index;
      return result;
    });
    this.userfavourite = this.userfavourite.slice(0, data.index).concat(data.results);
    this.emitChange();
  }
  refresh() {
    this.emitChange()
  }
  get() {
    return {
      userfavourite: this.userfavourite,
      inputs: this.inputs
    };
  }
  dehydrate() {
    return {
      userfavourite: this.userfavourite,
      inputs: this.inputs
    };
  }
  rehydrate(state) {
    this.userfavourite = state.userfavourite;
    this.inputs = state.inputs;
  }
}

UserfavouriteStore.storeName = 'UserfavouriteStore';
UserfavouriteStore.handlers = {
  [Actions.UPDATE_FEEDBACK_USERFAVOURITE_SUCCESS]: 'handleUpdateFeedbackUserfavourite',
  [Actions.LOAD_USERFAVOURITE_SUCCESS]: 'handleUserfavourite',
  [Actions.REFRESH_USERFAVOURITE]: 'refresh'
};

export default UserfavouriteStore;


// WEBPACK FOOTER //
// ./src/stores/UserfavouriteStore.js